import { render, staticRenderFns } from "./BoxeWinEdit.vue?vue&type=template&id=1ef61062&scoped=true&"
import script from "./BoxeWinEdit.vue?vue&type=script&lang=js&"
export * from "./BoxeWinEdit.vue?vue&type=script&lang=js&"
import style0 from "./BoxeWinEdit.vue?vue&type=style&index=0&id=1ef61062&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef61062",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ef61062')) {
      api.createRecord('1ef61062', component.options)
    } else {
      api.reload('1ef61062', component.options)
    }
    module.hot.accept("./BoxeWinEdit.vue?vue&type=template&id=1ef61062&scoped=true&", function () {
      api.rerender('1ef61062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BoxeWinEdit.vue"
export default component.exports